/**
 * What the mapping screens read: the import's fields, a real run's columns,
 * and the settings on that run's rows. The preview waits until a person stops
 * typing, and always reads the same run the sample did.
 */

import { getFields, getPreview, getSample } from "@/lib/integrations/api";
import type { Settings } from "@/lib/integrations/settings";

import { useDebounced, useKeyed } from "./hooks";

export function useMappingData(code: string | null, settings: Settings) {
  const fields = useKeyed(code ? `fields|${code}` : null, () => getFields(code ?? ""));
  const rowsKey = JSON.stringify(settings.rows);
  const sample = useKeyed(code ? `sample|${code}|${rowsKey}` : null, () => getSample(code ?? "", { settings, limit: 50 }));
  const run = sample.data?.runId ?? null;
  const settled = useDebounced(JSON.stringify(settings), 600);
  const preview = useKeyed(code && run ? `preview|${code}|${run}|${settled}` : null, () =>
    getPreview(code ?? "", { settings: JSON.parse(settled) as Settings, run, limit: 200 }),
  );
  return { fields, sample, run, preview };
}

export type MappingData = ReturnType<typeof useMappingData>;
